import { render, staticRenderFns } from "./JFollow.vue?vue&type=template&id=027e1003&scoped=true"
import script from "./JFollow.vue?vue&type=script&lang=js"
export * from "./JFollow.vue?vue&type=script&lang=js"
import style0 from "./JFollow.vue?vue&type=style&index=0&id=027e1003&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e1003",
  null
  
)

export default component.exports